import { Link } from 'react-router-dom';
import { profile } from "../assets/images"
import ThemeToggle from '../ThemeToggle';
import Viewer from '../Viewer';

const Home = (params) => {
  const global = params["global"];
  const [lang, setLang] = global["lang"];
  const [theme, setTheme] = global["theme"];
  const translations = global.translations;

  return (<div className="wrapper">
    <div className="content">
      <div className="card-holder">
        <div className="card" id="card1">
          <img id="profile-picture" alt="Nikitas Marmatakis profile picture" src={profile}></img>
        </div>
        <div className="card" id="card2">
          <h1 id="title-text" className={theme}>
            {translations["Nikitas Marmatakis"][lang]}
          </h1>
          <h5 className={theme} style={{ marginTop: "5px", maxWidth: "410px" }}>
            {translations["desc"][lang]}
          </h5>
          <div className="title-btn-holder">
            <Link to="mailto:nikitas@marmatakis.dev" className={theme + " main-btn"} id="contact-btn">
              {translations["Contact me"][lang]}
            </Link>
            <Link to="https://github.com/marmatakis" target="_blank">
              <img className={"icon " + theme} id="github" src="/icons/github.png"></img>
            </Link>
            <Link to="https://www.linkedin.com/in/marmatakis/" target="_blank">
              <img className={"icon " + theme} id="linkedin" src="/icons/linkedin.png"></img>
            </Link>
          </div>
        </div>
      </div>
    </div>
    {/* <div className="content">
      <div className="card-holder">
        <div className="card" id="card2">
          <h1 id="title-text" className={theme}>
            Ship me a physical <br />business card
          </h1>
          <h5 className={theme} style={{ marginTop: "5px", maxWidth: "410px" }}>
            Enter your address and I will send you a business card for free, mails internationally
          </h5>
          <div className="title-btn-holder">
            <Link to="mailto:nikitas@marmatakis.dev" className={theme + " main-btn"} id="contact-btn">
              Submit
            </Link>
          </div>
        </div>

        <div className="card" id="card1">
          <div style={{ height: "400px" }} id="business-card"><Viewer /></div>
        </div>
      </div> */}
    {/* </div> */}
    {/* <ThemeToggle global={global} /> */}
  </div>);
}

export default Home;